<template>
  <div class="cart__payment-options">
    <p class="cart__totals__continue">
      <span class="cart__totals__continue__or">or</span>
    </p>
    <div class="center">
      <div id="paypal-button">
        <three-dots-loading v-show="isLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import ThreeDotsLoading from '~/components/loadings/three-dots'
import paypalButton from '~/mixins/paypalButton'

export default {
  name: 'PaypalCheckout',
  components: {
    ThreeDotsLoading,
  },
  mixins: [paypalButton],
  props: {
    orderNumber: {
      type: [Number, String],
      required: true,
    },
  },
  async fetch() {
    try {
      const {
        active,
        enable_guest_checkout: guestCheckout,
        shazam_in_store: shazam,
        payment_method_id: paymentMethodId,
      } = await this.$axios.$get('/paypal/info', {
        params: {
          ...this.$store.getters.storeInfo,
        },
      })
      if (active && shazam && guestCheckout)
        this.initPaypalButton(guestCheckout, paymentMethodId)
    } catch (err) {
      this.$el.remove()
    }
  },
}
</script>

<style lang="scss" scoped>
#paypal-button {
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.cart__totals__continue {
  text-align: center;
  padding: 10px 0;
  margin: 0;
  line-height: 9px;
}
.cart__totals__continue__or {
  text-transform: uppercase;
  display: block;
  color: #a2a2a6;
  font-size: 10px;
}

@media (min-width: $screen_tablet) {
  .cart__totals__continue {
    display: block;
  }
}
</style>
